<template>
  <button
    class="btn"
    :type="type"
    :disabled="disabled || isProcessing"
    @click="$emit('click', $event)"
  >
    <span
      v-if="isProcessing"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    />

    <slot />
  </button>
</template>

<script>
  export default {
    props: {
      isProcessing: {
        type: Boolean,
      },

      disabled: {
        type: Boolean,
      },

      type: {
        type: String,
        default: 'button',
      },
    },
  }
</script>

<style>

</style>
